module.exports = __webpack_public_path__ + "static/img/wrapper-library.b62833d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/topImg/wrapper-library.jpg
// module id = t8Lf
// module chunks = 9